export default __webpack_public_path__ + "static/media/cloud-upload-new.f1e2c016.svg";